<div class="content-header d-flex al-end sp-between" [ngClass]="pageCurrent == 'Dashboard' || pageCurrent == 'Configuraciones' ? 'home':''">
  <div>
    <span class="fs-2 fw-extrabold" [ngClass]="pageCurrent == 'Dashboard' || pageCurrent == 'Configuraciones'? 'text-white':'text-black'">
      {{pageCurrent == 'Productos'?'Productos':pageCurrent}}</span>
  </div>
  <ng-container *ngIf="rol == 3 && pageCurrent != 'Dashboard' ">
    <div class="d-flex al-center gap">
      <div class="text-end">
        <div>
          <span class="fs-5 fw-bold" [ngClass]="pageCurrent == 'Configuraciones' ? 'text-white':''">{{ user.nombres.split(' ')[0]}} {{ user.nombres.split(' ')[1] }}</span>
        </div>
        <div>
          <span class="fs-6 fw-regular" [ngClass]="pageCurrent == 'Configuraciones' ? 'text-white':''">{{ user.correo }}</span>
        </div>
      </div>
      <ng-container *ngIf="user.imagen_url">
        <div class="avatar rounded-circle" style="background-image: url({{user.imagen_url}});"></div>
      </ng-container>
      <ng-container *ngIf="!user.imagen_url">
        <div class="avatar rounded-circle"></div>
      </ng-container>
    </div>
  </ng-container>
</div>